
import { defineComponent } from "vue";
import { Form, Field } from "vee-validate";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
//import Swal from "sweetalert2/dist/sweetalert2.min.js";
import OrganizationModal from "@/components/modals/forms/settings/OrganizationModal.vue";
// import * as Yup from "yup";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "new-entity-course",
  components: {
    Form,
    Field,
    Datatable,
    OrganizationModal,
  },
  data() {
    return {
      batch: {},
      employee: {},
      details: {},
      weekplan: {},
      entityTypes: [],
      industry: [],
      entityInfos: [],
      divisions: [],
      districts: [],
      subDistricts: [],
      empDistricts: [],
      tableData: [
        {
          id: 1,
          full_name: "XYZ Multinational Ltd.",
          short_name: "XYZ",
          created: "01-12-2013",
          modified: "04-03-2014",
        },
        {
          id: 2,
          full_name: "Sky Digital Ltd.",
          short_name: "Sky Digital",
          created: "01-12-2013",
          modified: "04-03-2014",
        },
      ],
      tableHeader: [
        {
          name: "Actions",
          key: "actions",
          sortable: false,
        },
        {
          name: "Full Name",
          key: "full_name",
          sortable: true,
        },
        {
          name: "Short Name",
          key: "short_name",
          sortable: true,
        },
        {
          name: "Created",
          key: "created",
          sortable: true,
        },
        {
          name: "Modified",
          key: "modified",
          sortable: true,
        },
      ],
      loading: false,
      courseInfoData: false,
      showCourseNotice: false,
      showtrainingProviderNotice: false,
      lists: [],
      search: "",
      data: {},
      organizations: [],
    };
  },
  async created() {
    await this.getEntityTypes();
    await this.getEntityInfos();
  },
  methods: {
    async formSubmit() {
      //form submit
    },
    async getEntityInfos() {
      await ApiService.get("entity/infos")
        .then((response) => {
          this.entityInfos = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getEntityTypes() {
      await ApiService.get("entity/types")
        .then((response) => {
          this.entityTypes = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    courseInfo() {
      this.courseInfoData = true;
    },
    courseNotice() {
      this.showCourseNotice = true;
    },
    trainingProviderNotice() {
      this.showtrainingProviderNotice = true;
    },
  },
  setup() {
    const AssociationSchema = [];
    return {
      AssociationSchema,
    };
  },
});
